export default __webpack_public_path__ + "static/media/js.8e7a0332.svg";